'use client';

import { PostHogProvider } from 'posthog-js/react';

import { posthogConfigAppRouter } from './PostHogConfig';

export function CSPostHogProvider({ children }: { children: React.ReactNode }) {
  return (
    <PostHogProvider
      apiKey={process.env.NEXT_PUBLIC_POSTHOG_KEY || ''}
      options={posthogConfigAppRouter}
    >
      {children}
    </PostHogProvider>
  );
}
